import React, { useEffect, useRef, useState } from 'react';
import { useFirestore } from 'react-redux-firebase';
import SelectUsers from './SelectUsers';
import Functions from '../../api/Functions';
import Loading from '../generalComponets/Loading';
import { DatePicker } from 'react-materialize';
import { triviaQuestionRef } from '../../api/fbCollections';
import { dateToMMDDYYYY, dateToYYYYMMDD, todayToYYYYMMDD } from '../../utils/DateUtil';

function AssignQuestions(props) {
  const firestore = useFirestore();
  const options = ['All', 'Question', 'Date'];
  const [optionQuestions, setOptionQuestions] = useState(options[1]);
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState(todayToYYYYMMDD());
  const [selectQuestions, setSelectQuestions] = useState([]);
  const [triviaQuestions, setTriviaQuestions] = useState([]);
  const [showProcess, setShowProcess] = useState(false);
  const [validUsers, setValidUsers] = useState(true);
  const [validQuestions, setValidQuestions] = useState(true);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [replaceQuestion, setReplaceQuestion] = useState(false);
  const childRef = useRef();

  useEffect(() => getTriviaQuestions(firestore), [firestore]);

  const getTriviaQuestions = (firestore) => {
    firestore
      .collection(triviaQuestionRef)
      .orderBy('type', 'asc')
      .get()
      .then((querySnapshot) => {
        const triviaQuestions = [];
        querySnapshot.forEach((doc) => {
          triviaQuestions.push(doc.data());
        });
        setTriviaQuestions(triviaQuestions);
      });
  };

  const selectQuestion = (question) => {
    if (selectQuestions.includes(question)) {
      const sQuestions = selectQuestions.filter((q) => q.id !== question.id);
      setSelectQuestions(sQuestions);
      setForceUpdate(forceUpdate + 1);
    } else {
      const sQuestions = selectQuestions;
      sQuestions.push(question);
      setSelectQuestions(sQuestions);
      setForceUpdate(forceUpdate + 1);
    }
  };

  const selectQuestionsByDate = (day) => {
    const selectQuestions = triviaQuestions.filter((tq) => tq.day === day);
    setSelectQuestions(selectQuestions);
    setForceUpdate(forceUpdate + 1);
  };

  const assignQuestions = () => {
    const profiles = childRef.current.getProfiles();
    if (
      profiles &&
      profiles.length > 0 &&
      (optionQuestions === options[0] || (selectQuestions && selectQuestions.length > 0))
    ) {
      setShowProcess(true);
      setValidUsers(true);
      setValidQuestions(true);
      Functions.assignQuestions(
        profiles,
        optionQuestions === options[1] || optionQuestions === options[2] ? selectQuestions : triviaQuestions,
        replaceQuestion,
      )
        .then(() => {
          setShowProcess(false);
          setForceUpdate(forceUpdate + 1);
          props.history.goBack();
        })
        .catch(() => {
          setShowProcess(false);
        });
    } else {
      setShowProcess(false);
      setValidUsers(false);
      setValidQuestions(false);
    }
  };

  const renderQuestion = (question) => {
    return (
      <div className="card">
        <div className="card-content">
          <div className="row">
            <div className="col s8">
              <h6>{question.question}</h6>
              <h6>Type: {question.type}</h6>
              <h6>Day: {question.day}</h6>
            </div>
            <div className="col s2 center">
              <div className="switch">
                <label>
                  <input
                    type="checkbox"
                    checked={selectQuestions.includes(question)}
                    value={selectQuestions.includes(question)}
                    onChange={() => selectQuestion(question)}
                  />
                  <span className="lever" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderQuestions = () => {
    return (
      <div className="scheme-container">
        <div>
          {triviaQuestions.map((q, index) => (
            <div key={index}>{renderQuestion(q)}</div>
          ))}
        </div>
      </div>
    );
  };

  const renderOptionQuestions = () => {
    return (
      <div className="row">
        <label className="col s6">
          <input
            name="questions"
            type="radio"
            onChange={() => setOptionQuestions(options[0])}
            checked={optionQuestions === options[0] ? 'checked' : ''}
          />
          <span className="radio-option">{options[0]}</span>
        </label>
        <label className="col s6">
          <input
            name="questions"
            type="radio"
            onChange={() => setOptionQuestions(options[1])}
            checked={optionQuestions === options[1] ? 'checked' : ''}
          />
          <span className="radio-option">{options[1]}</span>
        </label>
        <label className="col s6">
          <input
            name="questions"
            type="radio"
            onChange={() => {
              setOptionQuestions(options[2])
              selectQuestionsByDate(day);
            }}
            checked={optionQuestions === options[2] ? 'checked' : ''}
          />
          <span className="radio-option">{options[2]}</span>
        </label>
      </div>
    );
  };

  const selectDate = () => (
    <div className="row">
      <div className="col">
        <p>Date: {date != null ? dateToMMDDYYYY(date) : null}</p>
        <p>Day Format: {date != null ? dateToYYYYMMDD(date) : null}</p>
        <DatePicker
          options={{
            defaultDate: date,
          }}
          onChange={(value) => {
            const date = new Date(value);
            date.setHours(0, 0, 0, 0);
            const day = dateToYYYYMMDD(date);
            setDay(day);
            setDate(date);
            selectQuestionsByDate(day);
          }}
        />
      </div>
    </div>
  );

  const selectAssignationType = () => {
    return (
      <div>
        <label>Replace Questions</label>
        <div className="switch">
          <label>
            <input
              type="checkbox"
              checked={replaceQuestion}
              value={replaceQuestion}
              onChange={() => setReplaceQuestion(!replaceQuestion)}
            />
            <span className="lever" />
          </label>
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <h5>Assign Questions</h5>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col s6">
          {!validUsers ? <h6 className="red-text">Select Users</h6> : <div />}
          {!validQuestions ? <h6 className="red-text">Select Questions</h6> : <div />}
          <br />
          {renderOptionQuestions()}
          {optionQuestions === options[2] ? selectDate() : <div />}
          {renderQuestions()}
        </div>
        <div className="col s6">
          <button className="btn" onClick={assignQuestions}>
            Assign Questions
          </button>
          {selectAssignationType()}
          <SelectUsers ref={childRef} showQuestionStatus={true} />
        </div>
      </div>
    </div>
  );
}

export default AssignQuestions;
